import { usePermission } from "./PermissionProvider";
const ActionPermission = ({ pageKey, action, children }) => {
  const { permissions } = usePermission();
  const key = pageKey?.toLowerCase();
  const allowedActions = permissions.actions[key] || [];
  if (!allowedActions.includes(action)) return null;
  return children;
};

export default ActionPermission;
